export default "\n<app-table></app-table>";